<template>
    <div class="fixed z-50 items-center w-5 h-5 mt-1 mr-3 top-5 left-5 md:hidden" v-on:click="openMenu = !openMenu" >
        <img class="w-full" src="/images/menu_open.png" v-if="openMenu" alt=""/>
        <img class="w-full" src="/images/menu_close.png" v-if="!openMenu" alt=""/>
    </div>
    <nav class="sticky top-0 hidden h-full pt-10 w-80 bg-enriqueto_yellow md:block" id="adminMenu">
        <Link href="/">
            <div class="mb-5 text-center ml-7" id="logo-admin">
                <img class="w-32" src="/images/enriquetofrutas_darklogo.png" v-if="dark_mode" alt="" />
                <img class="w-32" src="/images/enriquetofrutas_logo.png" v-if="!dark_mode" alt="" />
            </div>
        </Link>
        
        <div class="mt-10">
            <div class="hidden md:block">
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/' }"
                    href="/"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Home</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin' }"
                    href="/admin"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Dashboard</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/products' }"
                    href="/admin/products"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Productos</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/categories' }"
                    href="/admin/categories"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Categories</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/taxonomy' }"
                    href="/admin/taxonomy"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Taxonomía</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/users' }"
                    href="/admin/users"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Usuarios</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/production' }"
                    href="/admin/production"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Producción</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/blog' }"
                    href="/admin/blog"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Blog</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/config' }"
                    href="/admin/config"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Configuración</Link
                >
                <a
                    href="/api/documentation"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >API</a
                >
            </div>
        </div>
        <Link
            href="/logout"
            method="post"
            as="button"
            type="button"
            class="absolute hidden align-middle ml-7 text-enriqueto_green md:block bottom-3"
            v-if="$page.props.user != null"
            >Logout</Link
        >
    </nav>
    <transition name="menu">
        <div
            id="mobile-menu"
            class="fixed top-0 z-40 w-full h-full p-3 pt-16 md:hidden bg-enriqueto_yellow"
            v-if="openMenu"
        >
            <SearchComponent />
            <div class="block w-full mt-8 text-left">
                                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/' }"
                    href="/"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Home</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin' }"
                    href="/admin"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Dashboard</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/products' }"
                    href="/admin/products"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Productos</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/categories' }"
                    href="/admin/categories"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Categories</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/taxonomy' }"
                    href="/admin/taxonomy"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Taxonomía</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/users' }"
                    href="/admin/users"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Usuarios</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/production' }"
                    href="/admin/production"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Producción</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/blog' }"
                    href="/admin/blog"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Blog</Link
                >
                <Link
                    :class="{ 'bg-light_yellow2': $page.url === '/admin/config' }"
                    href="/admin/config"
                    class="block py-2 align-middle pl-7 text-enriqueto_green"
                    >Configuración</Link
                >
                <Link
                    href="/logout"
                    method="post"
                    as="button"
                    type="button"
                    class="block mx-2 my-2 align-middle text-enriqueto_green"
                    v-if="$page.props.user != null"
                    >Logout</Link
                >
            </div>
        </div>
    </transition>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import SearchComponent from "../Shared/SearchComponent.vue";
import CurrecySwitcher from "./CurrencySwitcher.vue";
import DarkModeSwitcher from "./DarkModeSwitcher.vue";
import { ref } from "vue";
import { computed } from "vue";
import { useStore } from "vuex";

export default {
    components: { Link, SearchComponent, CurrecySwitcher, DarkModeSwitcher },
    setup() {
        const openMenu = ref(false);
        const store = useStore();

        const dark_mode = computed(() => store.state.dark_mode);
        return {
            openMenu,
            dark_mode,
        };
    },
};
</script>

<style>
.menu-enter-active {
    animation: animation 0.5s ease-in reverse;
}
.menu-leave-active {
    animation: animation 0.5s ease-in;
}
@keyframes animation {
    0% {
        opacity: 1;
        left: 0%;
    }
    100% {
        opacity: 0;
        left: -100%;
    }
}
</style>
